<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="items"
            item-key="id"
            class="elevation-1"
        >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Inventory</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialog = true">
                        New Inventory Entry
                    </v-btn>
                </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)">
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
        <NewInventoryEntry :dialog="dialog" @update:dialog="dialog = $event" />
    </div>
</template>

<script>
import NewInventoryEntry from './Dialogs/NewInventoryEntry.vue';
export default {
    name: 'MaintenanceInventory',
    props: {
        items: Array,
        headers: Array
    },
    components: {
        NewInventoryEntry
    },
    data() {
        return {
            dialog: false
        };
    },
    methods: {
        editItem(item) {
            this.dialog = true;
        },
        deleteItem(item) {
            this.dialog = true;
        }
    }
};
</script>
